// extracted by mini-css-extract-plugin
export default {"mills":"mills__KNEHp","no_wrap":"no_wrap__1PxEe"};